import Cookies from 'js-cookie';
import { on } from 'delegated-events';

const MAX_ITEMS = 20;
const COOKIE_NAME = 'wishlist-cookie';
let array = [];

// stary format { id } mieszał ProductID z OptionID — takie wpisy pomijamy
try {
    const parsed = JSON.parse(Cookies.get(COOKIE_NAME) || '[]');
    if (Array.isArray(parsed)) {
        array = parsed.filter(item => item && Number(item.pid) > 0);
    }
} catch (e) {
    array = [];
}

function updateCount() {
    const wishlistLink = document.getElementById('wishlist-box');

    if (wishlistLink) {
        wishlistLink.setAttribute('data-wishlist-count', array.length);
    }
}

export function WishlistDrawing() {
    const existingIds = new Set(array.map(item => Number(item.pid)));

    document.querySelectorAll('[data-wishlist-id]').forEach(wishlistItem => {
        const pid = Number(wishlistItem.getAttribute('data-wishlist-id'));

        wishlistItem.classList.toggle('existing', existingIds.has(pid));
    });
}

export function WishlistBinding() {
    updateCount();

    on('click', '[data-wishlist-id]', function () {
        const pid = Number(this.getAttribute('data-wishlist-id'));

        if (!(pid > 0)) return;

        const index = array.findIndex(item => Number(item.pid) === pid);

        if (index > -1) {
            array.splice(index, 1);
        } else {
            if (array.length >= MAX_ITEMS) {
                array.shift();
            }

            array.push({ pid, date: Date.now() });

            if (typeof exponea !== 'undefined') {
                fetch(`/api/frontend/FetchDetails?productId=${pid}`, { credentials: 'same-origin' })
                    .then(response => response.ok ? response.json() : null)
                    .then(data => {
                        if (data) exponea.track('wishlist', data);
                    })
                    .catch(() => { });
            }
        }

        Cookies.set(COOKIE_NAME, JSON.stringify(array), { expires: 30 });

        updateCount();
        WishlistDrawing();
    });
}
